import { Pipe, PipeTransform } from '@angular/core';
import { Util } from '../utils/functions';

@Pipe({
  name: 'cleanUrl'
})
export class CleanUrlPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    const service = Util.eliminarDiacriticos(value.toLowerCase().replace(/[' ']+/g, '-'));
    return [service];
  }

}
